/* eslint-disable react/jsx-props-no-spreading */

"use client";

import { useSearchParams } from "next/navigation";
import React from "react";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import WithdrawalFormContent from "@/components/molecules/withdrawal-verification-section/withdrawal-form-content";
import { useSessionTimeout } from "@/hooks/use-session-timeout";
import { CombinedWithdrawalVerification } from "@/utils/schema/withdrawal-verification-schema.utils";

import WithdrawalHeaderBanner from "./withdrawal-header-banner/withdrawal-header-banner";

function WithdrawalVerification({
  ...props
}: Readonly<CombinedWithdrawalVerification>) {
  const searchParams = useSearchParams();
  const withdrawalId = searchParams.get("policyId");
  const { current } = useWizard();

  // Implement 1-hour session timeout
  useSessionTimeout({
    timeoutDuration: 60 * 60 * 1000,
    redirectPath: "/",
  });

  return (
    <main
      data-testid="withdrawal-verification-test-id"
      className="bg-surface-neutral-option-2 !min-h-[100vh] md:px-spacing-xxl lg:px-spacing-6xl px-spacing-l"
    >
      {/* Top image & header banner */}
      <div className="pt-spacing-l md:pt-spacing-xl lg:pt-spacing-xxl flex flex-col gap-spacing-m md:gap-spacing-xl">
        <WithdrawalHeaderBanner {...props.withdrawalImageBannerArea["0"]} />
      </div>
      <div className="flex flex-col gap-spacing-m md:gap-spacing-xl py-spacing-m md:py-spacing-l">
        {/* Verification Form */}
        <div className="grid lg:grid-cols-12 lg:col-span-12 gap-spacing-l">
          <div className="col-span-12 lg:col-span-7 bg-surface-neutral-option-1 p-spacing-l md:p-spacing-xl rounded-radius-xxl">
            <WithdrawalFormContent
              {...props.withdrawalQuestionArea["0"]}
              withdrawalId={withdrawalId}
              showPostCode={current?.uiElementControls?.showPostCode}
              showPhoneNumber={current?.uiElementControls?.showPhoneNumber}
              phoneNumberLength={
                current?.brandSpecificParams?.phoneNumberLength as number
              }
              phoneNumberRegex={
                current?.brandSpecificParams?.phoneNumberRegex as string
              }
              postCodeMinLength={
                current?.brandSpecificParams?.postCodeMinLength as number
              }
              postCodeMaxLength={
                current?.brandSpecificParams?.postCodeMaxLength as number
              }
              postCodeRegex={
                (current?.brandSpecificParams?.postCodeRegex as string) ||
                String.raw`^(\d{5}|\d{4}|\d{4}[- ]?\d{3})$`
              }
            />
          </div>
        </div>
      </div>
    </main>
  );
}

export default WithdrawalVerification;
